import { TaskAccessResponse } from './model'
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'

export interface State extends EntityState<TaskAccessResponse> {
  isLoaded: boolean
  isUpdating: boolean
}

export const adapter: EntityAdapter<TaskAccessResponse> = createEntityAdapter<TaskAccessResponse>({
  selectId: (item: TaskAccessResponse) => item.pkey,
})

export const initialState: State = adapter.getInitialState({
  isLoaded: false,
  isUpdating: false,
})
